function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m1570.78 794.929c0-27.909-18.49-50.567-41.28-50.567h-123.84c-22.78 0-41.28 22.658-41.28 50.567v101.133c0 27.908 18.5 50.566 41.28 50.566h123.84c22.79 0 41.28-22.658 41.28-50.566z"
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m1632.03 971.183c0-33.806-22.1-61.251-49.33-61.251h-230.23c-27.23 0-49.34 27.445-49.34 61.251v122.497c0 33.81 22.11 61.25 49.34 61.25h230.23c27.23 0 49.33-27.44 49.33-61.25z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1210.58 -698.86)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m1210.58 698.86h514v514h-514z",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.970617 0 0 .890148 54.9707 88.8138)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m1192.22 687.42h527.499v575.186h-527.499z",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "m1424.98 1188.44c0-6.2-5.45-11.23-12.17-11.23h-73.05c-6.72 0-12.18 5.03-12.18 11.23v22.48c0 6.2 5.46 11.24 12.18 11.24h73.05c6.72 0 12.17-5.04 12.17-11.24z",
  fill: "#fff",
  strokeWidth: 4.67,
  transform: "matrix(1.0577576036 0 0 1.2496026453 -92.531693561 -301.67640462)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1607.58 1188.44c0-6.2-5.45-11.23-12.17-11.23h-73.05c-6.72 0-12.18 5.03-12.18 11.23v22.48c0 6.2 5.46 11.24 12.18 11.24h73.05c6.72 0 12.17-5.04 12.17-11.24z",
  fill: "#fff",
  strokeWidth: 4.67,
  transform: "matrix(1.0577576036 0 0 1.2496026453 -100.229149812 -301.67640462)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1411.78 672.659c0-13.08-10.62-23.7-23.7-23.7s-23.7 10.62-23.7 23.7v48.003c0 13.08 10.62 23.7 23.7 23.7s23.7-10.62 23.7-23.7z",
  fill: "#ebebeb",
  strokeWidth: 6,
  transform: "matrix(1.03027 0 0 1.12341 -42.435536 -18.594554498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1411.78 672.659c0-13.08-10.62-23.7-23.7-23.7s-23.7 10.62-23.7 23.7v48.003c0 13.08 10.62 23.7 23.7 23.7s23.7-10.62 23.7-23.7z",
  fill: "#ebebeb",
  strokeWidth: 6,
  transform: "matrix(1.03027 0 0 1.12341 94.17723573 -18.664992305)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.49749 0 0 1.33299 -741.714 -227.848)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m1570.78 794.929c0-27.909-18.49-50.567-41.28-50.567h-123.84c-22.78 0-41.28 22.658-41.28 50.567v101.133c0 27.908 18.5 50.566 41.28 50.566h123.84c22.79 0 41.28-22.658 41.28-50.566z",
  fill: "#ebebeb"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 1388.27,
  cy: 866.022,
  rx: 20.441,
  ry: 19.79,
  transform: "matrix(.673360736 0 0 .85171684275 484.6309648 91.03181357475)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 1554.52,
  cy: 870.728,
  rx: 20.642,
  ry: 17.635,
  transform: "matrix(.666617648 0 0 .95578269975 479.461264 -3.58913985)"
})), /*#__PURE__*/React.createElement("path", {
  d: "m1570.78 794.929c0-27.909-18.49-50.567-41.28-50.567h-123.84c-22.78 0-41.28 22.658-41.28 50.567v101.133c0 27.908 18.5 50.566 41.28 50.566h123.84c22.79 0 41.28-22.658 41.28-50.566z",
  fill: "none",
  stroke: "#000",
  strokeWidth: 4.52
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.25298 0 0 1.10047 -382.884 -73.5189)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m1632.03 971.183c0-33.806-22.1-61.251-49.33-61.251h-230.23c-27.23 0-49.34 27.445-49.34 61.251v122.497c0 33.81 22.11 61.25 49.34 61.25h230.23c27.23 0 49.33-27.44 49.33-61.25z",
  fill: "#ebebeb"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 1368.14,
  cy: 1074.91,
  rx: 40.563,
  ry: 40.741,
  transform: "matrix(.8513957172 0 0 1.052394265 227.1136558095 -124.82789596)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 1368.14,
  cy: 1074.91,
  rx: 40.563,
  ry: 40.741,
  transform: "matrix(.8513957172 0 0 1.052394265 378.397146465 -124.82789596)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: 6.16
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 1302.55,
  cy: 1097.93,
  rx: 4.299,
  ry: 5.939,
  transform: "matrix(.76498493925 0 0 .6875547252 334.199270512 300.794291)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 1302.55,
  cy: 1097.93,
  rx: 4.299,
  ry: 5.939,
  transform: "matrix(.76498493925 0 0 .6875547252 597.78264892 345.6606485)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 1302.55,
  cy: 1097.93,
  rx: 4.299,
  ry: 5.939,
  transform: "matrix(.76498493925 0 0 .6875547252 608.11181623 300.794291)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 1302.55,
  cy: 1097.93,
  rx: 4.299,
  ry: 5.939,
  transform: "matrix(.76498493925 0 0 .6875547252 563.72320231 330.1518953)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 1302.55,
  cy: 1097.93,
  rx: 4.299,
  ry: 5.939,
  transform: "matrix(.76498493925 0 0 .6875547252 374.120244115 330.1518953)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 1302.55,
  cy: 1097.93,
  rx: 4.299,
  ry: 5.939,
  transform: "matrix(.76498493925 0 0 .6875547252 345.0839533 342.88291565)"
}))), /*#__PURE__*/React.createElement("path", {
  d: "m1632.03 971.183c0-33.806-22.1-61.251-49.33-61.251h-230.23c-27.23 0-49.34 27.445-49.34 61.251v122.497c0 33.81 22.11 61.25 49.34 61.25h230.23c27.23 0 49.33-27.44 49.33-61.25z",
  fill: "none",
  stroke: "#000",
  strokeWidth: 5.43
}))));

var SvgHippo = function SvgHippo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    viewBox: "0 0 514 514",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHippo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hippo.d2f4cdea.svg";
export { ForwardRef as ReactComponent };